import React, { useState } from 'react'
import Bredcom from '../Bredcom/Main'
import axios from 'axios'
import { baseURL } from '../../config'
import Loader from './Loader/Loader'
import Headerone from '../headerone/newMain'

import Accordion from 'react-bootstrap/Accordion';

const SpecialRegex=/^[A-Za-z\s]*$/
function Careers() {
    const [errorStatus, setErrorStatus] = useState(false)
    const [isLoading,setIsLoading]=useState(false)
    const [payload, setPayload] = useState({
        position: "",
        location: "",
        name: "",
        total_experience: "",
        qualification: "",
        current_salary: "",
        expected_salary: "",
        notice_join: "",
        contact_number: "",
        profile: {
            fileName: '',
            url: '',
            type: ''
        },
        resume: {
            fileName: '',
            url: '',
            type: ''
        }
    })
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setPayload((values) => ({ ...values, [name]: value }))
    }
    const handlFile = (e, key) => {
        const { files } = e.target;
        if (files?.length > 0) {
            let name = key == 'image' ? 'profile' : 'resume';
            let file_name = files[0].name
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            }).then((res) => {
                setPayload((values) => ({
                    ...values,
                    [name]: {
                        fileName: file_name,
                        url: res,
                        type: file_name?.split('.')?.pop()
                    }
                }))
            });
        }
    }
    const handleremove = (name) => {
        let fileUrl = name == 'image' ? 'profile' : 'resume';
        setPayload((values) => ({
            ...values,
            [fileUrl]: {
                fileName: "",
                url: "",
                type: ""
            }
        }))
    }
    const handleSubmit = (e) => {
        setIsLoading(true)
        e.preventDefault()
        if(payload?.name==""||Boolean(payload?.name.match(SpecialRegex))==false||payload?.contact_number<10||Boolean(payload?.name.match(SpecialRegex))==false){
            setErrorStatus(true)
        setIsLoading(false)

            // var x = document.getElementById("snackbar");
            // x.className = "show";
            // setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
        }else{
        let url = `${baseURL}/addCareer`
        axios.post(url, payload, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            }
        }).then((response) => {
            var x = document.getElementById("successsnackbar");
            x.className = "show";
            setTimeout(function () { x.className = x.className.replace("show", ""); }, 4000);
            setErrorStatus(false)
        setIsLoading(false)

            setPayload({
                position: "",
                location: "",
                name: "",
                total_experience: "",
                qualification: "",
                current_salary: "",
                expected_salary: "",
                notice_join: "",
                contact_number: "",
                profile: {
                    fileName: '',
                    url: '',
                    type: ''
                },
                resume: {
                    fileName: '',
                    url: '',
                    type: ''
                }
            })
            console.log('response:::', response)
        }).catch(error=>{
            setErrorStatus(false)
        setIsLoading(false)

        })
    }
    }
    console.log('payload::', payload)
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Careers" />
            <section className="careerdetail">
                <div className="container">
                    {/* <div className='industryImg'>
                        <center> <img src="https://admission.mvn.edu.in/wp-content/uploads/2023/07/Hiring-MVN.jpg" alt="" /></center>
                    </div> */}
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='jobitem'>
                                <h3>Current Openings</h3>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        </>
    )
}

export default Careers 